exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-bricks-file-viewer > table,\n.uu5-bricks-file-viewer > table > tbody,\n.uu5-bricks-file-viewer > table > tbody > tr,\n.uu5-bricks-file-viewer > table > tbody > tr > td {\n  border: 0 !important;\n}\n.uu5-bricks-file-viewer > table {\n  margin: 0 !important;\n}\n.uu5-bricks-file-viewer.uu5-bricks-table > table > tbody > tr > td {\n  white-space: pre;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./bricks/file-viewer.less
// module id = 212
// module chunks = 0